import React, { useState } from 'react'
import useActivityMetrics from '../useActivityMetrics'
import { SvgIcon, Stack, Typography } from '@mui/material'
import { DonutChartData, UnifiedDonutCharts } from '../../../../../shared/components/DonutCharts'
import { ReactComponent as StrategyIcon } from '../../../../../assets/images/strategy.svg'
import useActivitiesDisplayName from '../../../../../shared/hooks/useDisplayNames/variants/useActivitiesDisplayName'
import List from '../../components/List'
import { Activity } from '../../../../../shared/queries/useGetActivitiesQuery'
import { EmptyPlaceholder } from '../../../../../shared/components/EmptyPlaceholder'

const ActivityByFunctionDonutCharts = () => {
    const { legend, data } = useActivityMetrics()

    const activitiesDisplayName = useActivitiesDisplayName()

    const [listData, setListData] = useState<DonutChartData<Activity>>(null)

    const title = `${activitiesDisplayName.singular} by Function`
    const isEmpty = !data.length

    return (
        <Stack direction="column" flex={9}>
            <Stack direction="row" alignItems="center" gap={1} color="figma.grayscale.textHier1" mb={1}>
                <SvgIcon
                    component={StrategyIcon}
                    inheritViewBox
                    fontSize="small"
                    color="inherit"
                    sx={{ fontSize: '24px' }}
                />
                <Typography variant="20x500" color="inherit">
                    {title}
                </Typography>
            </Stack>

            {isEmpty && (
                <Stack
                    flex={1}
                    direction="column"
                    gap={1}
                    px={2}
                    py={2.75}
                    bgcolor="figma.grayscale.tier7"
                    borderRadius="16px"
                >
                    <EmptyPlaceholder title="" subtitle="No data to display" />
                </Stack>
            )}
            {!isEmpty && <UnifiedDonutCharts data={data} legend={legend} onTotalClick={setListData} />}

            <List
                data={listData}
                legend={legend}
                handleClose={() => setListData(null)}
                getName={(activity) => activity.title}
                getPathname={() => '/activities'}
            />
        </Stack>
    )
}

export default ActivityByFunctionDonutCharts
